import {useSelector} from 'react-redux';

import {getQuoteItems} from 'desktop/pages/cart/store/selectors';

import {GLASSES_CARE_SKU} from 'desktop/pages/checkout/store/selectors/constants';
import {getOrderReviewItems} from 'desktop/pages/checkout/store/selectors/orderReviewItems/orderReviewItems';
import {CheckoutItemOptionType} from 'desktop/types/checkoutItemsType';

type ListType = {options: {[key: string]: CheckoutItemOptionType}}[];

const getItemsHasGlassesCare = (quoteItemsList: ListType): boolean =>
    quoteItemsList.some(({options}): boolean =>
        Object.values(options || {}).some((option): boolean => option?.sku === GLASSES_CARE_SKU),
    );

/**
 *  useHasGlassesCareFor Returns true if cart has some product with glasses care upgrade
 */
export const useHasGlassesCare = (): boolean => {
    const orderReviewItemsList = useSelector(getOrderReviewItems);
    const quoteItems = useSelector(getQuoteItems);
    const quoteItemsList = quoteItems.length > 0 ? quoteItems : orderReviewItemsList;

    return getItemsHasGlassesCare(quoteItemsList as ListType);
};
